import React from 'react';

// import { Container } from './styles';
interface Props {
    children: React.ReactNode;
}

const Label = ({children}:Props) => {
  return <div>{children}</div>
}

export default Label;